import { render } from "./FeaturedRow.vue?vue&type=template&id=69b3a302&scoped=true"
import script from "./FeaturedRow.vue?vue&type=script&lang=js"
export * from "./FeaturedRow.vue?vue&type=script&lang=js"

import "./FeaturedRow.vue?vue&type=style&index=0&id=69b3a302&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b3a302"]])

export default __exports__